module.exports = __webpack_public_path__ + "static/demmin-01-b5828fce50212d3a2577b59d75d1247a.jpg";